<template>
  <time-card v-if="timeCard && user" :time-card-id="id" :user="user" :admin-mode="true" />
  <loading-overlay v-else />
</template>

<script>
import { TimeCardService } from '@/common/services/time_card.service';
import { UserService } from '@/common/services/user.service';
import HelperMethods from '@/common/mixins/helper_methods';
import LoadingOverlay from '@/common/components/loading-overlay.vue';
import TimeCard from '@/common/components/time-card.vue';

export default {
  name: 'TimeManagementEdit',
  mixins: [HelperMethods],
  components: {
    LoadingOverlay,
    TimeCard,
  },
  data() {
    return {
      id: Number(this.$route.params.id),
      user: null,
      timeCard: null,
    };
  },
  created() {
    this.getTimeCard(this.id);
  },
  methods: {
    getTimeCard(id) {
      TimeCardService.get(id)
        .then((response) => {
          this.timeCard = response.data;
          this.getUser(response.data.user_id);
        });
    },
    getUser(id) {
      UserService.get(id)
        .then((response) => {
          this.user = response.data;
        });
    },
  },
};
</script>

<style scoped>

</style>
